import React, { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext';
import { db } from "../firebase-config";
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@material-ui/icons/ArrowForwardIosSharp';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Button, Typography, Container, GlobalStyles, CssBaseline, AppBar, Toolbar, List, ListItem, ListItemText } from '@mui/material'
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import logo from '../components/small_components/eternadna-logo.png'
import {
  collection,
  getDocs,
  query,
  orderBy
} from "firebase/firestore";

function Dashboard() {
  const { logout } = useAuth()
  const [database, setDatabase] = useState([]);

  useEffect(() => {
    const usersCollectionRef = collection(db, "users");
    const getUsers = async () => {
      const data = await getDocs(query(usersCollectionRef, orderBy('timeSent', 'desc')));
      setDatabase(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getUsers();
  }, []);

  const style = {
    width: '100%',
    bgcolor: 'background.paper',
  };

  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  }));

  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
      {...props}
    />
  ))(({ theme }) => ({
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, .05)'
        : 'rgba(0, 0, 0, .04)',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
      marginLeft: theme.spacing(1),
    },
  }));

  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
  }));

  const DisplayArray = ({ array }) => {
    return (
      array.map((array_item) => {
        return array_item.value + ", "
      })
    )
  }

  const CheckTrue = ({ item }) => {
    if (item === true) {
      return "True"
    } else {
      return "False"
    }
  }

  const DataList = ({name, data}) => {
    return (
      <ListItem divider>
        <ListItemText sx={{ width: '30%', marginRight: '10%' }}>{name}</ListItemText>
        <ListItemText sx={{ width: '60%' }}>{data}</ListItemText>
      </ListItem>
    )
  }

  return (
    <Container maxWidth='xl'>
      <div>
        <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
        <CssBaseline />
        <AppBar
          position="static"
          elevation={0}
          style={{ background: '#fff', padding: '16px' }}
        >
          <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
            <img alt="eternadna logo" src={logo} height="40" />
            <nav>
              <Button variant="contained" onClick={logout}>
                Sign Out
              </Button>
            </nav>
          </Toolbar>
        </AppBar>
      </div>
      <Typography variant='h3' textAlign={'center'}>Dashboard</Typography>
      {database.map((user) => {
        return (
          <Accordion sx={{ marginTop: '24px' }} >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>{user.name} | {user.timeSent}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <List sx={style}>
                <DataList name="Name" data={user.name} />
                <DataList name="Email" data={user.email} />
                <DataList name="Gender" data={user.gender} />
                <DataList name="DNA File" data={user.dna_file} />
                <DataList name="Date Of Birth" data={user.date_of_birth} />
                <DataList name="Weight" data={user.weight} />
                <DataList name="Height" data={user.height} />
                <DataList name="Dietary Restrictions" data={user.dietary_restrictions} />
                <DataList name="Activity Level" data={user.activity_level} />
                <DataList name="Ethnicity" data={user.ethnicity.value} />
                <DataList name="Other Ethnicity" data={user.ethnicity_others} />
                <DataList name="Country Of Birth" data={user.country_of_birth.label} />
                <DataList name="Grandmother" data={user.grandmother} />
                <DataList name="Grandfather" data={user.grandfather} />
                <DataList name="Report Language" data={user.report_language.value} />
                <DataList name="Boost Flavour" data={user.boost} />
                <DataList name="Stamina Exercise" data={user.stamina_exercise} />
                <DataList name="Strength Exercise" data={user.strength_exercise} />
                <DataList name="Soreness" data={user.soreness} />
                <DataList name="Sports Injuries" data={user.sports_injuries} />
                <DataList name="Out Of Breath" data={user.out_of_breath} />
                <DataList name="Motivation" data={user.motivation} />
                <DataList name="Losing Weight" data={user.losing_weight} />
                <DataList name="Muscle Development" data={user.muscle_development} />
                <DataList name="Muscle Cramps" data={user.muscle_cramps} />
                <DataList name="Obesity" data={user.obesity} />
                <DataList name="Skin Tightness" data={user.skin_tightness} />
                <DataList name="Dry Skin" data={user.dry_skin} />
                <DataList name="Skin Irritation" data={user.skin_irritation} />
                <DataList name="Red Skin" data={user.red_skin} />
                <DataList name="Younger" data={user.younger} />
                <DataList name="Skin Concerns" data={<DisplayArray array={user.skin_concerns} /> } />
                <DataList name="Other Skin Concerns" data={user.skin_concerns_others} />
                <DataList name="Symptoms" data={<DisplayArray array={user.symptoms} /> } />
                <DataList name="Smoke" data={user.smoke} />
                <DataList name="Endurance Sport" data={user.endurance_sport} />
                <DataList name="Muscle Sport" data={user.muscle_sport} />
                <DataList name="Alcoholic" data={user.alcoholic} />
                <DataList name="Sunscreen" data={user.sunscreen} />
                <DataList name="Rested" data={user.rested} />
                <DataList name="Stress" data={user.stress} />
                <DataList name="Physical Job" data={user.physical_job} />
                <DataList name="Fruits" data={user.fruits} />
                <DataList name="Vegetables" data={user.vegetables} />
                <DataList name="Vegetarian" data={user.vegetarian} />
                <DataList name="Fish" data={user.fish} />
                <DataList name="Meat" data={user.meat} />
                <DataList name="Junk Food" data={user.junk_food} />
                <DataList name="Sweetened Drink" data={user.sweetened_drink} />
                <DataList name="Carbonated Drink" data={user.carbonated_drink} />
                <DataList name="Conditions" data={<DisplayArray array={user.conditions} /> } />
                <DataList name="Other Conditions" data={user.conditions_others} />
                <DataList name="Allergies" data={<DisplayArray array={user.allergic} /> } />
                <DataList name="Other Allergies" data={user.allergic_others} />
                <DataList name="Diseases" data={<DisplayArray array={user.diseases} /> } />
                <DataList name="Other Diseases" data={user.diseases_others} />
                <DataList name="Drugs" data={<DisplayArray array={user.drugs} /> } />
                <DataList name="Other Drugs" data={user.drugs_others} />
                <DataList name="Antibiotics" data={user.Antibiotics} />
                <DataList name="Anti-depressants" data={user.Anti} />
                <DataList name="Blood Pressure" data={user.Blood_Pressure} />
                <DataList name="Cholesterol-Lowering" data={user.Cholesterol} />
                <DataList name="Diabetes" data={user.Diabetes} />
                <DataList name="Diuretics" data={user.Diuretics} />
                <DataList name="Hormone" data={user.Hormone} />
                <DataList name="Facilitate" data={user.Facilitate} />
                <DataList name="Gout" data={user.Gout} />
                <DataList name="Salicylate" data={user.Salicylate} />
                <DataList name="Thyroid" data={user.Thyroid} />
                <DataList name="Blood-thinning" data={user.Blood_thinning} />
                <DataList name="Painkillers" data={user.Painkillers} />
                <DataList name="Drugs Not Listed" data={user.Other} />
                <DataList name="Medications" data={user.medications} />
                <DataList name="Other Medications" data={user.medications_others} />
                <DataList name="Health" data={user.health} />
                <DataList name="Other Health" data={user.health_others} />
                <DataList name="Pregnant" data={user.pregnant} />
                <DataList name="Breastfeeding" data={user.breastfeeding} />
                <DataList name="Hormonal" data={user.hormonal} />
                <DataList name="Health Goals" data={<DisplayArray array={user.health_goals} /> } />
                <DataList name="Other Health Goals" data={user.health_goals_others}  />
                <DataList name="Research Consent" data={<CheckTrue item={user.research_consent} /> } />
                <DataList name="Personal Data" data={<CheckTrue item={user.personal_data} /> } />
                <DataList name="Terms Of Service" data={<CheckTrue item={user.terms_of_service} /> } />
              </List>
            </AccordionDetails>
          </Accordion>          
        )
      })}
    </Container>
  )
}

export default Dashboard